if (!customElements.get('ugc-videos')) {
  class UgcVideos extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.multicolumn__items',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSliderMobile = this.dataset.enableSliderMobile === 'true';
      this.slidesPerViewMobile = parseFloat(this.dataset.slidesPerViewMobile) || 2.4;

      this.sliderInstance = false;

      if (!this.enableSliderMobile) return;

      this.init();
      document.addEventListener('matchMobile', () => {
        this.init();
      });
      document.addEventListener('unmatchMobile', () => {
        this.init();
      });
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.initSlider();
      } else {
        this.destroySlider();
      }
    }

    initSlider() {
      if (!this.sliderWrapper) return;

      const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
      const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

      const sliderOptions = {
        slidesPerView: this.slidesPerViewMobile,
        spaceBetween: spaceBetween,
        loop: false,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
      }

      if (Shopify.designMode && typeof this.sliderInstance === 'object') {
        document.addEventListener('shopify:block:select', (e) => {
          if (e.detail.sectionId != this.sectionId) return;
          const { target } = e;
          const index = Number(target.dataset.index);

          if (Number.isFinite(index)) {
            this.sliderInstance.slider.slideToLoop(index);
          }
        });
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      if (this.sliderWrapper) {
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        this.sliderWrapper.classList.add(this.classes.grid);
      }
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('ugc-videos', UgcVideos);
}
